import React from 'react';
import { View } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import Text from '@/components/Typography/Text';
import { CheckRow, money } from './AutoTopupEditor';
import { suggestedMonthlyLimitForPackPrice, thresholdForOneClickOptIn } from '@/lib/autoTopupOffer';

export default function AutoTopupCheckoutOptIn({ pack, checked, onChange, disabled = false }) {
  const { colors } = useTheme();
  if (!pack) return null;
  const threshold = thresholdForOneClickOptIn(pack.credits);
  if (!threshold) return null;
  return <View style={{ borderWidth: 1, borderColor: colors.border_color_secondary, borderRadius: 12, padding: 14, gap: 10 }}>
    <CheckRow label="Enable auto top-up after this purchase" checked={checked} onChange={onChange} disabled={disabled}>
      <Text size="s" weight="semibold">Keep credits ready with auto top-up</Text>
      <Text size="xs" color="secondary">Optional · Enable after this purchase</Text>
    </CheckRow>
    {checked && <>
      <Text size="s">I authorize {money(pack.price)} for {pack.credits.toLocaleString()} credits when my balance falls below {threshold.toLocaleString()}, up to {money(suggestedMonthlyLimitForPackPrice(pack.price))} per month.</Text>
      <Text size="xs" color="secondary">Uses your saved payment method. At most once every 24 hours. Checks can take 10 minutes. New cards wait 24 hours. One-time discounts do not apply. You can manage or turn this off in Credits settings.</Text>
    </>}
  </View>;
}
